<template>
<h1><font-awesome-icon icon="lightbulb" /></h1>
<u>Lichtst&auml;rke</u>
<br>
<svg class="bar" viewBox="0 0 220 44" width="220" height="44" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="lux-grad" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#1e2a4a" />
      <stop offset="35%" stop-color="#6b7fa8" />
      <stop offset="70%" stop-color="#f2d27a" />
      <stop offset="100%" stop-color="#fff6c8" />
    </linearGradient>
  </defs>
  <rect x="10" y="8" width="200" height="12" rx="6" fill="url(#lux-grad)" stroke="#5b4510" />
  <g stroke="#fff" stroke-linecap="round">
    <line v-for="t in TICKS" :key="t.text" :x1="t.x" y1="22" :x2="t.x" y2="27" />
  </g>
  <g font-size="9" font-family="Georgia, 'Times New Roman', serif" text-anchor="middle" fill="#fff">
    <text v-for="t in TICKS" :key="t.text" :x="t.x" y="38">{{ t.text }}</text>
  </g>
  <polygon v-if="valid" :points="`${x - 5},0 ${x + 5},0 ${x},10`" fill="#fff" stroke="#3b2e10" stroke-width="1" />
</svg>
<b>{{ valid ? klux : '--' }} kLux</b>
<div v-if="level">{{ level }}</div>
</template>

<script>
// logarithmic scale 0.1 .. 100 kLux over the bar (x = 10 .. 210)
const LOG_MIN = -1
const LOG_MAX = 2
const X0 = 10
const WIDTH = 200

function toX(klux) {
  const l = Math.min(LOG_MAX, Math.max(LOG_MIN, Math.log10(klux)))
  return X0 + (l - LOG_MIN) / (LOG_MAX - LOG_MIN) * WIDTH
}

const TICKS = [0.1, 1, 10, 100].map(v => ({ text: String(v), x: toX(v) }))

// upper bound (exclusive) in kLux
const LEVELS = [
  { below: 0.1, name: 'dunkel' },
  { below: 1, name: 'Dämmerung' },
  { below: 10, name: 'bedeckt' },
  { below: 50, name: 'hell' },
  { below: Infinity, name: 'direktes Sonnenlicht' }
]

export default {
  name: 'LightLux',
  props: {
    klux: Number
  },
  data() {
    return { TICKS }
  },
  computed: {
    valid() {
      return Number.isFinite(this.klux)
    },
    x() {
      return toX(Math.max(this.klux, 0.001))
    },
    level() {
      return this.valid ? LEVELS.find(l => this.klux < l.below).name : ''
    }
  }
}
</script>

<style scoped>
.bar {
  display: block;
  margin: 14px auto 6px;
}
</style>
